module.exports = __webpack_public_path__ + "media/images/logo-ea837e115d087f4bced2ba353616b34b.svg";